import { render } from "./timeline-month.view.vue?vue&type=template&id=08970040&scoped=true"
import script from "./timeline-month.view.vue?vue&type=script&lang=js"
export * from "./timeline-month.view.vue?vue&type=script&lang=js"

import "./timeline-month.view.vue?vue&type=style&index=0&id=08970040&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08970040"]])

export default __exports__